

























import { computed, defineComponent, ref } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import useUserPublicData from "@/hooks/useUserPublicData";
import { userPublicDataFieldsWithStoryInfo } from "@/lib/fieldsHelper";
import BaseIconButton from "@/components/BaseIconButton";
import BaseSpinner from "@/components/BaseSpinner";
import CustomScroll from "@/components/CustomScroll";
import CreatorsSliderItem from "./components/CreatorsSliderItem";

export default defineComponent({
  name: "CreatorsSlider",
  components: { BaseSpinner, BaseIconButton, CreatorsSliderItem, CustomScroll },
  props: {
    size: { type: Number },
  },
  setup(props) {
    const creatorsList = ref<UserPublicData[]>([]);
    const { loading, users, getFirstPage } = useUserPublicData(
      computed(() => ({ role: "creator", sort: "IS_LIVE,DESC;IS_ONLINE,DESC;ID,DESC", discoveryOnly: true })),
      props.size,
      userPublicDataFieldsWithStoryInfo()
    );

    const getData = async () => {
      await getFirstPage();
      creatorsList.value = users.value;
    };
    getData();

    return { loading, creatorsList };
  },
});
